import { connect } from 'react-redux'
import * as FollowRecommendationActions from '../stores/follow_recommendation/actions';
import FollowRecommendationsFirstRunComponent from '../components/follow_recommendations_first_run';

const mapStateToProps = (state) => {
  return {
    user: state.default.user,
    recommendedFollows: state.default.recommendedFollows,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFollow: (slug) => {
      dispatch(FollowRecommendationActions.follow(slug));
    },
    onUnFollow: (slug) => {
      dispatch(FollowRecommendationActions.unfollow(slug));
    },
    onReset: () => {
      dispatch(FollowRecommendationActions.reset());
    },
    onLoadRecommendedFollows: () => {
      dispatch(FollowRecommendationActions.recommendFollowers(5));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowRecommendationsFirstRunComponent);



// WEBPACK FOOTER //
// ./src/containers/follow_recommendations_first_run_container.js